// removed by extract-text-webpack-plugin
module.exports = {"menu__item":"menu-hashed__menu__item__3qTl5","menu__itemIcon":"menu-hashed__menu__itemIcon__29vun"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/layouts/Menu/menu-hashed.scss
// module id = 703
// module chunks = 0